import { Navigate, useLocation, useParams } from "react-router-dom";

import { ModuleName } from "../../utils/module-name";
import { decodeSlug } from "../../utils/slug";
import { getModuleDetailPage } from "../utils/getModuleDetailPage";

import { ROUTES } from "@/constants/routes";

function ModuleDetailPage() {
  const { integrationName, moduleName, clientId } = useParams<{
    integrationName?: string;
    moduleName?: string;
    clientId?: string;
  }>();
  const location = useLocation();

  const decodedModuleName: ModuleName | null = moduleName
    ? (decodeSlug(moduleName) as ModuleName)
    : (location.pathname
      .split("/")
      .find((segment) =>
        Object.values(ModuleName).includes(segment as ModuleName)
      ) as ModuleName | null);

  if (!decodedModuleName) {
    return null;
  }

  const isClientContext = Boolean(clientId);
  const component = getModuleDetailPage(decodedModuleName, isClientContext);

  // No dedicated client page for this module — fall back to the client's integration
  // overview (module cards + configure) instead of rendering nothing.
  if (isClientContext && component === null && clientId && integrationName) {
    return (
      <Navigate
        to={`/${ROUTES.clients}/${clientId}/${ROUTES.integrations}/${integrationName}`}
        replace
      />
    );
  }

  return component;
}

export default ModuleDetailPage;
